import containerFuild from '../html-snippets/container-fuild.js';
import css from '../css-snippets/section-sowhatbuy-reward.js';

const BG_DESKTOP = 'https://cdn.skyfastimg.com/images/2026/09/09/image-6aa0be8d6f779a52a2be5961.webp?w=1000';
const BG_MOBILE = 'https://cdn.skyfastimg.com/images/2026/09/09/image-6aa0be91dd60ed4fef9279ad.webp?w=1000';
const HEADER_ICON_LEFT = 'https://cdn.skyfastimg.com/images/2026/09/09/image-6aa0bec494d7da206daee1f7.png?w=500';
const HEADER_ICON_RIGHT = 'https://cdn.skyfastimg.com/images/2026/09/09/image-6aa0bec82248342fa4b15fac.png?w=500';
const SIGNATURE_IMAGE = 'https://cdn.skyfastimg.com/images/2026/09/09/image-6aa0beec38385b5443ef4996.png?w=1000';
const STAT_ICON = 'https://cdn.skyfastimg.com/images/2026/09/09/image-6aa0befafd3c4e85e443bc08.png?w=500';

const defaultItems = [
  { value: '32.000+', icon: STAT_ICON, label: 'Sold Globally' },
  { value: '120.000+', icon: STAT_ICON, label: '4.9 Stars Reviews' },
  { value: '5.290+', icon: STAT_ICON, label: 'Satisfied Customers' },
];

const renderStatItem = item => `
  <div
    class="sowhatbuy-reward__stat-item"
    data-attribute="sowhatbuy-reward__stat-item"
  >
    <div
      class="sowhatbuy-reward__stat-value"
      data-attribute="sowhatbuy-reward__stat-value"
    >${item.value}</div>
    <div class="sowhatbuy-reward__stat-label">
      <img
        data-attribute="sowhatbuy-reward__stat-icon"
        src="${item.icon}"
        alt=""
      />
      <span
        class="sowhatbuy-reward__stat-label-text"
        data-attribute="sowhatbuy-reward__stat-label-text"
      >${item.label}</span>
    </div>
  </div>
`;

const contentHtml = `
  <div class="container">
    <div
      class="sowhatbuy-reward"
      data-attribute="sowhatbuy-reward-content"
      data-background-image-desktop="${BG_DESKTOP}"
      data-background-image-mobile="${BG_MOBILE}"
      style="--bg-desktop: url(${BG_DESKTOP}); --bg-mobile: url(${BG_MOBILE});"
    >
      <div class="sowhatbuy-reward__inner" data-attribute="sowhatbuy-reward__inner">
        <div class="sowhatbuy-reward__header" data-attribute="sowhatbuy-reward__header">
          <div
            class="sowhatbuy-reward__header-icon sowhatbuy-reward__header-icon--left"
            data-attribute="sowhatbuy-reward__header-icon-left"
            data-show="true"
          >
            <img
              data-attribute="sowhatbuy-reward__header-icon-left-img"
              src="${HEADER_ICON_LEFT}"
              alt=""
            />
          </div>
          <div
            class="sowhatbuy-reward__header-title"
            data-attribute="sowhatbuy-reward__header-title"
          >
            <h2 style="text-align:center;"><strong>Optician Recommended</strong></h2>
          </div>
          <div
            class="sowhatbuy-reward__header-icon sowhatbuy-reward__header-icon--right"
            data-attribute="sowhatbuy-reward__header-icon-right"
            data-show="true"
          >
            <img
              data-attribute="sowhatbuy-reward__header-icon-right-img"
              src="${HEADER_ICON_RIGHT}"
              alt=""
            />
          </div>
        </div>

        <div
          class="sowhatbuy-reward__desc"
          data-attribute="sowhatbuy-reward__desc"
        >
          <p>This magnifier reduces eye strain, boosting clarity and independence for presbyopia &amp; macular degeneration users.</p>
        </div>

        <div
          class="sowhatbuy-reward__signature"
          data-attribute="sowhatbuy-reward__signature"
          data-show="true"
        >
          <img
            data-attribute="sowhatbuy-reward__signature-img"
            src="${SIGNATURE_IMAGE}"
            alt=""
          />
        </div>

        <div
          class="sowhatbuy-reward__stats"
          data-attribute="sowhatbuy-reward__stats"
        >
          ${defaultItems.map(renderStatItem).join('\n')}
        </div>
      </div>
    </div>
  </div>
`;

export default containerFuild(contentHtml, css, {
  backgroundColor: '#F8FAF5',
  textColor: '#ffffff',
  topPadding: true,
  bottomPadding: true,
});
